// Venta solo de contado: el cliente tiene una venta con crédito en curso en otra sucursal.
import { wizardErrorCode } from './api/wizardError';

export const CREDIT_IN_PROGRESS_OTHER_STORE_CODE = 'CREDIT_IN_PROGRESS_OTHER_STORE';

export const CREDIT_IN_PROGRESS_OTHER_STORE_MESSAGE =
    'Tiene una venta con crédito en curso en otra sucursal';

/** El silo rechazó crédito o derivación porque la venta es solo de contado. */
export function isCreditInProgressOtherStore(error: unknown): boolean {
    return wizardErrorCode(error) === CREDIT_IN_PROGRESS_OTHER_STORE_CODE;
}
